const ENV = {
  environment: import.meta.env.VITE_APP_ENV,
};

export default ENV;
